import { isEqual } from "lodash";
import { useRouter } from "next/router";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Button from "~/components/common/button";
import Filter from "~/components/pages/sectionNew/filterBlock/filter";
import SelectorMobile from "~/components/pages/sectionNew/selectorMobile";
import {
  setFilterParams,
  setIsFilterLoading,
} from "~/redux/action-creaters/filter";
import { declOfNum, getFilterUrl } from "~/utils";

import styles from "./index.module.scss";

export default function FilterPopup({
  sectionPageUrl,
  mobileFilterType,
  mobileFilterTypes,
  onHide,
  productCount,
}: any) {
  const router = useRouter();
  const dispatch = useDispatch();
  const { params, isFilterLoading, filter } = useSelector(
    (state: any) => state.filter,
  );
  const { count } = useSelector((state: any) => state.section);
  const [initialFilterParams, setInitialFilterParams] = useState({});

  useEffect(() => {
    setInitialFilterParams(params);
  }, []);

  const totalCheckedCnt = useMemo(() => {
    return Object.keys(params).filter(
      (param) => !["marka", "model", "kuzov"].includes(param),
    ).length;
  }, [params]);

  useEffect(() => {
    const body: any = document.querySelector("body");
    body.classList.add("popup");
    return () => {
      body.classList.remove("popup");
    };
  }, []);

  const mobilePopupTitle = useMemo(() => {
    if (mobileFilterType === mobileFilterTypes.marka) {
      return "Выбор марки";
    }
    if (mobileFilterType === mobileFilterTypes.model) {
      return "Выбор модели";
    }
    if (mobileFilterType === mobileFilterTypes.kuzov) {
      return "Выбор кузова";
    }
    return "Все фильтры";
  }, [mobileFilterType]);

  return (
    <div className={styles.WrapperPopup} id="popupBody">
      <div className={styles.PopupTop}>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
        <div
          className={styles.PopupTopClose}
          onClick={() => {
            onHide();
            dispatch(setFilterParams(initialFilterParams));
            setInitialFilterParams({});
          }}
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 1L1 13M1 1L13 13"
              stroke="#384250"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          {mobilePopupTitle}
        </div>
        {(totalCheckedCnt > 0 ||
          (params?.marka && mobileFilterType !== mobileFilterTypes.filter)) && (
          <>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <div
              className={styles.PopupTopReset}
              onClick={() => {
                setInitialFilterParams({});
                dispatch(setIsFilterLoading(true));
                if (mobileFilterType === mobileFilterTypes.filter) {
                  router.push(
                    getFilterUrl(sectionPageUrl, {
                      marka: params.marka,
                      model: params.model,
                      kuzov: params.kuzov,
                    }),
                  );
                } else {
                  router.push(sectionPageUrl);
                }
              }}
            >
              Сбросить
            </div>
          </>
        )}
      </div>
      <div className={styles.PopupBody}>
        {mobileFilterType !== mobileFilterTypes.filter && (
          <SelectorMobile sectionPageUrl={sectionPageUrl} />
        )}
        {mobileFilterType === mobileFilterTypes.filter && (
          <div className={styles.Filter}>
            <Filter
              productCount={productCount}
              sectionPageUrl={sectionPageUrl}
              onChangeUrl={(newUrl: string) => {
                // dispatch(setFilterParams());
                const filter = newUrl.split("/filter/")[1];
                const params: any = {};
                filter.split("/").forEach((item) => {
                  const [name, ...value] = item.split("-");
                  if (name && value) {
                    params[name] = value.filter((item) => item !== "or");
                  }
                });
                dispatch(setFilterParams(params));
              }}
            />
          </div>
        )}
      </div>
      <div className={styles.PopupBottom}>
        <Button
          label={`Показать ${declOfNum(filter.productCount || count, ["товар", "товара", "товаров"])}`}
          onClick={() => {
            onHide();
            if (!isEqual(initialFilterParams, params)) {
              router.push(getFilterUrl(sectionPageUrl, params));
            }
            setInitialFilterParams({});
          }}
          isLoading={isFilterLoading}
        />
      </div>
    </div>
  );
}
